<footer>
  <div class="footer-menu">
    เวอชั่น {{ appVersion }}
  </div>
  <div class="footer-content">
    <p>ระบบเรียกดูข้อมูลการจ่ายชำระเงินให้แก่ผู้ขาย</p>
    <p>Web Vendor </p>
  </div>
</footer>
